// @flow
import _pickBy from 'lodash/pickBy';
import gql from 'graphql-tag';
import { apolloQuery, apolloSubmitForm } from '../../core/data/apolloClient';
import { offlineTokenMetaModel } from './OfflineToken.model';

export function filterOfflineTokenInput(values) {
  return _pickBy(values, (_, key) => key in offlineTokenMetaModel.rules || key === 'id');
}

export function listOfflineTokens(filter, shape) {
  return apolloQuery(
    gql`query ($filter: String) {
          listOfflineTokens(officeId: $filter) ${shape}
        }`,
    { filter }
  );
}

export function getOfflineToken(token, shape) {
  return apolloQuery(
    gql`query ($token: String!) {
          getOfflineToken(token: $token) ${shape}
        }`,
    { token }
  );
}

export function createOfflineToken(inputValues, outputShape) {
  return apolloSubmitForm(
    gql`mutation ($input: OfflineTokenCreate!) {
          createOfflineToken(input: $input) ${outputShape}
        }`,
    { input: inputValues }
  );
}

export function revokeOfflineToken(inputValues, outputShape) {
  return apolloSubmitForm(
    gql`mutation ($input: OfflineTokenRevoke!) {
          revokeOfflineToken(input: $input) ${outputShape}
        }`,
    { input: inputValues }
  );
}
